export const initialState = {
  isLoading: false,
  isLoadingError: false
}

export default function(state=initialState, action) {
  // eslint-disable-next-line
  const { payload, type } = action

  switch(type) {
    case 'SET_LOADING':
      return {
        ...state,
        isLoading: true
      }
    case 'SET_LOADING_ERROR':
      return {
        ...state,
        isLoadingError: true
      }
    case 'UNSET_LOADING':
      return {
        ...state,
        isLoading: false
      }
    case 'UNSET_LOADING_ERROR':
      return {
        ...state,
        isLoadingError: false
      }
    case 'SET_SHOP_ORDER_TOTALS_LOADING':
      return {
        ...state,
        loadingShopOrderTotals: true
      }
    case 'UNSET_SHOP_ORDER_TOTALS_LOADING':
      return {
        ...state,
        loadingShopOrderTotals: false
      }
    case 'SET_TOOLTIP_LOADING':
      return {
        ...state,
        isTooltipLoading: true
      }
    case 'UNSET_TOOLTIP_LOADING':
      return {
        ...state,
        isTooltipLoading: false
      }
    default:
      return state
  }
}
